import React, { useState } from "react";
import "./Login.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../App";

const Login = ({ component: Component, ...rest }) => {
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");

  async function login(e) {
    e.preventDefault();
    await signInWithEmailAndPassword(auth, email, password)
      .then((user) => {
        window.location.href = "/dashboard";
      })
      .catch((error) => {});
  }

  return (
    <div className="login-wrap">
      <form className="login-form">
        <div className="form-group">
          <div className="login-username">
            <label htmlFor="Email">Email</label>
            <input
              type="text"
              className="form-control"
              id="Email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="login-password">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="login-submit">
            <button onClick={login}>
              <span>Login</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
